import styled from "styled-components";
import { Flex, Text } from "rebass/styled-components";
import { FaPlay, FaHeart, FaComment } from "react-icons/fa";

import "./index.css";
import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";
import { formatNumber } from "MVVM/Utilities/Clip";
import { IClip } from "MVVM/@types";

export const ClipStats = ({ clip }: { clip: IClip }) => {
  const calculatedTopSocial = Math.floor(clip.views * 0.066);
  const calculatedBottomSocial = Math.floor(clip.views * 0.009);

  const { track } = useAnalyticsContext();

  const handleClick = (locationIdentifier: string) => {
    track("Button - Click", {
      locationIdentifier: `${locationIdentifier}_player_social_click`,
      location: "embeddable_playlist",
    });

    const ajs_aid = window.rudderanalytics.getAnonymousId();
    window.open(
      `${window.location.origin}/clip/${clip.shareId}?ajs_aid=${ajs_aid}&clickSource=${locationIdentifier}`,
      "_blank",
    );
  };

  return (
    <StyledContainer className="player-social-container">
      <StyledIconContainer onClick={() => handleClick("views")}>
        <StyledViewIcon className="player-social-icon" />
        <StyledText className="player-social-text">
          {formatNumber(clip.views)}
        </StyledText>
      </StyledIconContainer>
      <StyledIconContainer onClick={() => handleClick("reactions")}>
        <StyledLikeIcon className="player-social-icon" />
        <StyledText className="player-social-text">
          {formatNumber(calculatedTopSocial)}
        </StyledText>
      </StyledIconContainer>
      <StyledIconContainer onClick={() => handleClick("comments")}>
        <StyledCommentIcon className="player-social-icon" />
        <StyledText className="player-social-text">
          {formatNumber(calculatedBottomSocial)}
        </StyledText>
      </StyledIconContainer>
    </StyledContainer>
  );
};

const StyledIconContainer = styled(Flex)`
  align-items: center;
  flex-direction: column;
  gap: 4px;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);

    .player-social-icon,
    .player-social-text {
      transform: scale(1.05);
    }
  }
`;

const StyledText = styled(Text)`
  font-size: 10.5px;
`;

const StyledContainer = styled(Flex)`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
  border-radius: 50px;
  cursor: pointer;
  flex-direction: column;
  gap: 8px;
  margin-right: 5px;
  padding: 8px 4px;
  pointer-events: auto;
  width: fit-content;
`;

const StyledViewIcon = styled(FaPlay)`
  color: ${({ theme }) => theme.colors.ice};
  height: 14px;
  width: 14px;
`;

const StyledLikeIcon = styled(FaHeart)`
  color: ${({ theme }) => theme.colors.heartRed};
  height: 14px;
  width: 14px;
`;

const StyledCommentIcon = styled(FaComment)`
  color: ${({ theme }) => theme.colors.ice};
  height: 14px;
  width: 14px;
`;
